import { render, staticRenderFns } from "./SwiperBadges.vue?vue&type=template&id=29168ed5&scoped=true&"
import script from "./SwiperBadges.vue?vue&type=script&lang=js&"
export * from "./SwiperBadges.vue?vue&type=script&lang=js&"
import style0 from "./SwiperBadges.vue?vue&type=style&index=0&id=29168ed5&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29168ed5",
  null
  
)

export default component.exports